import styled from 'styled-components';

const StyledContainer = styled.div<ContainerProps>`
	width: 100%;
	max-width: ${props => (props.width ? `${props.width}px` : '570px')};
	height: ${props => (props.height ? `${props.width}px` : 'auto')};
`;

export const Container = ({
	children,
	width,
	height
}: ContainerProps): JSX.Element => {
	return (
		<StyledContainer width={width} height={height}>
			{children}
		</StyledContainer>
	);
};

export default Container;

interface ContainerProps {
	children: any;
	width?: string | number;
	height?: string | number;
}

// interface StyledContainerProps {
// 	width?: string;
// 	height: string;
// }
